// Reusable "Eligible funding sources" mapping-guide trigger: an underlined info link that opens
// the EligibleFundingSourcesModal. Self-contained (owns its open state) so any screen can drop it in.
import { useState } from 'react';
import { styled, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Icon, Typography } from '../../components/atoms';
import { EligibleFundingSourcesModal } from './EligibleFundingSourcesModal';

const MappingGuideBox = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    cursor: 'pointer',
    '& .info-icon': {
        '--info-icon-fg': `${theme.palette.semantic.int.selected}`
    }
}));

const MappingGuideText = styled(Typography)(({ theme }) => ({
    color: theme.palette.semantic.int.selected,
    fontFamily: 'TT Commons Pro',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px' /* 125% */,
    textDecorationLine: 'underline',
    textDecorationStyle: 'solid',
    textDecorationSkipInk: 'none',
    textDecorationThickness: 'auto',
    textUnderlineOffset: 'auto',
    textUnderlinePosition: 'from-font'
}));

export const MappingGuideLink = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [showMappingGuide, setShowMappingGuide] = useState(false);

    return (
        <>
            <MappingGuideBox
                role="button"
                tabIndex={0}
                onClick={() => setShowMappingGuide(true)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        setShowMappingGuide(true);
                    }
                }}
            >
                <Icon id="info-icon-circle" size={12} fill={theme.palette.primary[50]} className="info-icon" />
                <MappingGuideText>{t('MAPPING_GUIDE_TEXT')}</MappingGuideText>
            </MappingGuideBox>
            {showMappingGuide && (
                <EligibleFundingSourcesModal open={showMappingGuide} onClose={() => setShowMappingGuide(false)} />
            )}
        </>
    );
};

export default MappingGuideLink;
